import { httpMethod, useApi } from './useApi';
export const useGetDocumentChunks = ({ documentId }) => {
    const { call, data, ...rest } = useApi({
        authenticated: true,
        path: 'document-chunks',
        httpMethod: httpMethod.GET,
        body: {},
        queryParams: {
            document_id: documentId,
        },
    });
    const responseData = data;
    return { call, data: responseData, ...rest };
};
